import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { CookieBanner } from '@/components/layout/CookieBanner';
import { ScrollProgress } from '@/components/ScrollProgress';

export const Layout = () => (
  <div className="relative flex min-h-screen flex-col">
    {/* global depth / ambience */}
    <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-[#00101a]">
      <div className="grid-bg absolute inset-0 opacity-[0.6]" />
      <div className="animate-blob absolute -top-40 left-1/2 h-[620px] w-[980px] -translate-x-1/2 rounded-full bg-brand/[0.08] blur-[170px]" />
      <div className="animate-blob absolute top-1/3 -left-40 h-[520px] w-[520px] rounded-full bg-brand/[0.045] blur-[160px]" style={{ animationDelay: '3s' }} />
      <div className="animate-blob absolute bottom-0 right-0 h-[560px] w-[680px] translate-x-1/4 rounded-full bg-[#00FFA3]/[0.05] blur-[170px]" style={{ animationDelay: '6s' }} />
      <div className="noise-overlay absolute inset-0" />
    </div>
    <ScrollProgress />
    <Navbar />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <CookieBanner />
  </div>
);
